/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2019, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

/**
 * AngularJs service that will handle api communication.
 */
angular.module('bulbApp.blockModule')
  .service('BulbDeletedUnitService', [
    'Restangular',
    '$http',
    '$rootScope',
    '$stateParams',
    'BulbAjaxService',
    'BulbAuthService',
    'SerialSaveService',
    'CONFIG',
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    BulbDeletedUnitService,
  ]);

function BulbDeletedUnitService(
  Restangular,
  $http,
  $rootScope,
  $stateParams,
  BulbAjaxService,
  BulbAuthService,
  SerialSaveService,
  CONFIG,
) {
  const that = this;
  this.authorAccountId = null;

  /**
   *  flag to indicate whether recently deleted tab is selected.
   */
  this.isRecentlyDeletedSelected = false;

  /**
   *  flag to indicate if user is  navigating to author page from recently deleted.
   */
  this.navigateToAuthor = false;

  /**
   * Checks if the current account is admin or org admin.
   * @returns {boolean}
   */
  this.isAdmin = function isAdmin() {
    return BulbAuthService.currentUser.roles.includes('ADMIN');
  };

  /**
   * Get count of deleted unit.
   */
  this.getDeletedUnitCount = function getDeletedUnitCount() {
    return $http.get(`/b/rest/accounts/${that.authorAccountId}/deletedUnitsCount`)
      .then((response) => response.data);
  };

  /**
   * Get list of deleted unit.
   */
  this.getDeletedUnits = function getDeletedUnits(accountId) {
    return Restangular.one(`accounts/${accountId}/deletedUnits`).get();
  };

  /**
   * Call api to delete unit.
   * @param unitId Id of unit to be deleted.
   * @param mode force or permanent.
   */
  this.delete = function deleteUnit(unitId, mode) {
    return SerialSaveService.save({
      save: () => Restangular.one('units', unitId).remove({ mode }),
    });
  };

  /**
   * Call api to get updated page units.
   */
  this.fetchAuthorUnits = function fetchAuthorUnits() {
    BulbAjaxService.getAuthor($stateParams.username).then((data) => {
      $rootScope.$broadcast('updatePageUnitDTO', data.unitDTOs[0]);
    });
  };

  /**
   * Call api to restore deleted unit.
   * @param unitId  Id of unit will be restore.
   */
  this.restore = function restore(unitId) {
    return SerialSaveService.save({
      save: () => Restangular.one(`units/${unitId}/restore?unpublished=true`).customPOST(),
    });
  };

  /**
   * Get deleted unit.
   * @param unitId Id of unit.
   */
  this.getDeletedUnit = function getDeletedUnit(unitId) {
    return Restangular.one('units', unitId).get({ deleted: true });
  };

  /**
   * Return the number of days after which the unit will be deleted.
   * @returns number of days
   */
  this.getDaysForDelete = function getDaysForDelete() {
    const secondsInOneDay = 60 ** 2 * 24;
    const secondsToConvert = Number(CONFIG.unit.softDeleteSeconds - CONFIG.unit.hardDeleteSeconds);
    if (secondsToConvert <= secondsInOneDay) {
      return 1;
    }
    return Math.floor(secondsToConvert / secondsInOneDay);
  };
}
